import React from 'react';
import ReactDOM from 'react-dom';
import classnames from 'classnames';
import { ReactionsIcon } from '@bizzabo/icons';

const ToggleReactionsButton = ({ visible, onClick }) => {
    const reactionsContainer = document.getElementById('live-broadcast-footer-left-container');

    if (!reactionsContainer) {
        return null;
    }

    return ReactDOM.createPortal(
        <button onClick={onClick} className={classnames('toggle-reactions-button', { 'active': visible })}>
            <ReactionsIcon />
        </button>,
        reactionsContainer
    );
};

export default ToggleReactionsButton;
